import * as React from 'react';
import * as _ from 'lodash';
import { ImageContainer, Image, ImageCategory, ViewImagesContainer, ViewImageSection, ViewImagesLabel, ViewImageSubtitle } from './styles';
import { LMMediadata } from 'features/Dealers/Listings/Images/state/types';



export interface ViewImageProps {
    image?: LMMediadata
    urlImage?: string
}


const ViewImage = (props: ViewImageProps) => {


    let url = (props.urlImage??getUrl(props.image?.urls));
    return (
        <ImageContainer >
            <Image src={url}></Image>
            {
                props.image && 
                <ImageCategory>{props.image?.category}</ImageCategory>
            }
        </ImageContainer>
    )
}


function getUrl(urls) {
    if (urls != undefined && urls.length > 0) {
        const urlthumbnail = urls.find(f => f.type == "THUMBNAIL");
        if (urlthumbnail != undefined)
            return urlthumbnail.url;

        const urlmain = urls.find(f => f.type == "MAIN");
        if (urlmain != undefined)
            return urlmain.url;

        return urls[0].url;
    }
    return "";

}

export default ViewImage